import React, { PureComponent } from 'react';
import './BUTTON.css';
import TOOLTIP from './TOOLTIP';

// two ways to use BUTTON
class BUTTON extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { pressed: false };
    }

    componentWillUnmount() {
        if (this.windowListener) {
            window.removeEventListener('mouseup', this.windowListener);
        }
    }

    mouseDown(e) {
        if (this.props.onDown) {
            this.props.onDown();
            return;
        }

        this.setState({ pressing: true, pressed: true });
        this.windowListener = function(event) {
            var shouldCallOnPress = false;
            if (this.state.pressed && this.props.onPress) {
                shouldCallOnPress = true;
            }

            this.setState({ pressing: false, pressed: false });
            window.removeEventListener('mouseup', this.windowListener);

            if (shouldCallOnPress) {
                this.props.onPress();
            }

            event.stopPropagation();
        }.bind(this);
        window.addEventListener('mouseup', this.windowListener);
        e.stopPropagation();
    }
    mouseEnter(e) {
        if (this.state.pressing) {
            this.setState({ pressed: true });
        }
    }

    mouseLeave(e) {
        if (this.state.pressing) {
            this.setState({ pressed: false });
        }
    }

    render() {
        var className = "btn ";
        if (this.state.pressed) {
            className += "btn-depressed ";
        }
        if (this.props.selected) {
            className += "btn-selected ";
        }
        if (this.props.className) {
            className += this.props.className;
        }

        var tooltip = undefined;
        if (this.props.tooltip) {
            tooltip = <TOOLTIP text={this.props.tooltip} />;
        }

        return <div className={className}
            onMouseDown={this.mouseDown.bind(this)}
            onMouseEnter={this.mouseEnter.bind(this)}
            onMouseLeave={this.mouseLeave.bind(this)}
            onClick={(e)=>e.stopPropagation()}>
            {this.props.children}
            {tooltip}
        </div>;
    }
}

export default BUTTON;



// WEBPACK FOOTER //
// ./src/walleris/BUTTON.js